import React from 'react';
import { Info } from '@phosphor-icons/react';
import classNames from 'classnames';
import { Tooltip } from '../general';

interface Props {
  isInModal?: boolean;
  className?: string;
}

const PhotoRules: React.FC<Props> = (props) => {
  const { isInModal, className } = props;

  const badImages = [
    {
      text: 'No other people, even at the background',
      note: 'Others in the photo may appear in the final video',
      images: [
        {
          src: require('../../assets/upload images/people/with woman.png'),
          alt: 'Person with other person',
        },
        {
          src: require('../../assets/upload images/people/with people.png'),
          alt: 'Person with people on background',
        },
      ],
    },
    {
      text: 'No hats, sunglasses or masks',
      images: [
        {
          src: require('../../assets/upload images/people/with hat.png'),
          alt: 'Person with hat',
        },
        {
          src: require('../../assets/upload images/people/with sunglasses.png'),
          alt: 'Person with sunglasses',
        },
        {
          src: require('../../assets/upload images/people/with mask.png'),
          alt: 'Person with mask',
        },
      ],
    },
  ];

  const imgClassName = classNames({
    'w-32 aspect-square': true,
    'sm:w-36': isInModal,
    'sm:w-40': !isInModal,
  });

  return (
    <div
      className={classNames(
        'w-full flex flex-col lg:flex-row gap-6 lg:gap-10',
        className,
      )}
    >
      <div
        className={classNames(
          'w-full flex flex-col items-center text-center p-4 gap-2 border-4 border-success-900 border-solid rounded-md',
          { 'lg:w-1/4': isInModal, 'lg:w-1/5': !isInModal },
        )}
      >
        <div className="font-semibold">✅ Good Image</div>

        <img
          src={require('../../assets/upload images/people/person.png')}
          alt="Good person position"
          className={imgClassName}
        />

        <div>Clear close-up of a face</div>
      </div>

      <div
        className={classNames(
          'w-full  flex flex-col items-center text-center p-4 gap-2 border-4 border-error-900 border-solid rounded-md',
          { 'lg:w-3/4': isInModal, 'lg:w-4/5': !isInModal },
        )}
      >
        <div className="font-semibold">❌ Avoid This</div>

        <div
          className={classNames({
            'flex flex-col gap-x-12 gap-y-8': true,
            'xl:flex-row': !isInModal,
          })}
        >
          {badImages.map((group) => (
            <div className="flex flex-col items-center gap-2" key={group.text}>
              <div className="flex flex-wrap lg:flex-nowrap justify-center gap-x-6 gap-y-3">
                {group.images.map((image) => (
                  <img
                    src={image.src}
                    alt={image.alt}
                    className={imgClassName}
                    key={image.src}
                  />
                ))}
              </div>

              <div>
                {group.text}{' '}
                {group.note && (
                  <Tooltip
                    text={group.note}
                    className="inline-block cursor-pointer hover:text-primary-900"
                  >
                    <Info weight="fill" />
                  </Tooltip>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PhotoRules;
